import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@devinforius/i-essentials';
import { ContactsService } from 'src/app/shared/services/contacts.service';
import { MeService } from 'src/app/shared/services/me.service';
import { MailsLockUnlockService } from 'src/app/shared/services/mails-lock-unlock.service';
import { MailLocks } from 'src/app/shared/models/mails/mails-lock';
import { Cols } from 'src/app/shared/models/cols';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-locked-courriers',
  templateUrl: './locked-courriers.component.html',
  styleUrls: ['./locked-courriers.component.scss'],
})
export class LockedCourriersComponent implements OnInit {
  public mails: MailLocks[] = [];
  public columns: Cols[] = [
    {
      field: 'courrierId',
      header: 'ID',
      format: (value) => {
        if (value) {
          return value.toString();
        } else {
          return '/';
        }
      },
    },
    {
      field: 'courrier',
      header: 'Courrier',
      format: (value) => {
        if (value?.objet) {
          return value.objet;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'contactName',
      header: 'Contact',
      format: (value) => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'date',
      header: 'Date',
      format: (value) => {
        if (value) {
          return moment(value).format('DD/MM/YYYY à HH:mm');
        } else {
          return '/';
        }
      },
      sort: (a, b, order) => {
        const val1 = moment(a, 'DD/MM/YYYY à HH:mm').isValid() ? moment(a, 'DD/MM/YYYY à HH:mm').unix() : null;
        const val2 = moment(b, 'DD/MM/YYYY à HH:mm').isValid() ? moment(b, 'DD/MM/YYYY à HH:mm').unix() : null;
        if (val1 === null) return 1;
        else if (val2 === null) return -1;
        else return val1 < val2 ? 1 * order : -1 * order;
      },
      sortable: true,
    },
    {
      field: 'lockMode',
      header: 'Verrouillage',
      format: (value) => {
        if (value === 'Read') {
          return 'Lecture';
        } else {
          return 'Ecriture';
        }
      },
    },
  ];
  public forselection: { click?: (value, item) => void; label: string; tooltip: string }[] = [
    {
      click: (selections) => {
        this.unlocks('Read', selections);
      },
      label: 'Déverrouiller en lecture',
      tooltip: '',
    },
    {
      click: (selections) => {
        this.unlocks('Write', selections);
      },
      label: 'Déverrouiller en écriture',
      tooltip: '',
    },
  ];
  public contactArray: { label: string; value: number }[] = [];
  public mode: string;
  public types: { label: string; value: string }[] = [
    { label: 'Lecture', value: 'Read' },
    { label: 'Ecriture', value: 'Write' },
  ];
  public isAdmin = false;
  public mailsAtStart: MailLocks[] = [];
  public totalRecords: number;
  public rows = 100;
  public first = 1;
  public loading = false;
  public firstPage = 0;

  constructor(
    public toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private titleService: Title,
    private translater: TranslateService,
    private contactsService: ContactsService,
    private meService: MeService,
    private mailsLockUnlockService: MailsLockUnlockService
  ) {}

  ngOnInit(): void {
    this.titleService.setTitle(this.translater.translate('tabsTitle.lockedMails'));
    this.spinner.show();
    this.contactsService.getLowInformationsContactsiCourrier().subscribe({
      next: (response) => {
        if (response.length > 0) {
          const temp = [];
          response.map((contact) => {
            if (contact) {
              temp.push({
                label: (contact.prenom ? contact.prenom : '') + ' ' + (contact.nom ? contact.nom : ''),
                value: contact.id,
              });
            }
          });
          this.contactArray = temp;
          this.getRightManagement();
          this.getLockedMails();
        }
      },
      error: (error) => {
        console.error('Error : ', error);
      },
    });
  }

  getLockedMails(pageNumber?: number) {
    this.spinner.show();
    let data = null;
    if (!data) {
      data = {
        pageNumber: pageNumber ? pageNumber : 1,
        pageSize: 100,
      };
    }
    this.mailsLockUnlockService.getAllLockedMails(data).subscribe({
      next: (res) => {
        this.mails = res.items.map((item) => new MailLocks(item));
        this.mails = this.mails.map((item) => {
          item.contactName = this.contactArray.find((contact) => contact.value === item.contactId)?.label;
          return item;
        });
        this.totalRecords = res.totalCount;
        this.rows = res.pageSize;
        this.first = res.pageNumber;
        this.mailsAtStart = this.mails;
        this.loading = true;
        this.spinner.hide();
      },
    });
  }

  getRightManagement() {
    this.meService.rightManagement().subscribe({
      next: (res) => {
        this.isAdmin = res.menu.users;
      },
    });
  }
  unlocks(mode: string, selections) {
    const data = {
      courrierIds: [],
    };
    selections.map((item) => {
      data.courrierIds.push(item.courrierId);
    });
    this.mailsLockUnlockService.unLock(mode, data).subscribe({
      next: () => {
        this.toastr.success('Les courriers ont été déverrouillés');
        this.getLockedMails();
      },
    });
  }

  filterContact(contact) {
    this.mails = this.mailsAtStart;
    const arrayContact = contact.value;

    if (arrayContact.length > 0) {
      this.mails = this.mails.filter((x) => arrayContact.includes(x.contactId));
    } else {
      this.mails = this.mailsAtStart;
    }
  }

  goTo(event) {
    const url = '/private/ic/tabs/';
    const config = environment;
    window.open(config.baseUrl + url + event.courrierId);
  }

  lazyLoadData(event) {
    this.first = event.first;
    const pageNumber = event.first / event.rows + 1;
    if (this.first !== pageNumber) {
      this.getLockedMails(pageNumber);
    }
  }
}
